var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "text-center" }, [
          _c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.errorMessage
      ? _c("div", { staticClass: "alert alert-warning" }, [
          _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.loading
      ? _c("div", [
          _vm.rules.length === 0
            ? _c("div", { staticClass: "alert alert-info" }, [
                _vm._v(
                  '\n      No rules have been created yet. Click "Add Rule" to create one.\n    '
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.rules.length > 0
            ? _c("div", [
                _c("table", { staticClass: "table table-striped" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Rule Type")]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.criteriaColumnHeader))]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Status")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Actions")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.rules, function(rule) {
                      return _c("tr", { key: rule.uuid }, [
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatRuleType(rule.rule_type)))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          rule.rule_type === "school" &&
                          rule.rule_config &&
                          rule.rule_config.school_uuids &&
                          rule.rule_config.school_uuids.length > 0
                            ? _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      rule.rule_config.school_uuids.length
                                    ) +
                                    " school(s)\n              "
                                )
                              ])
                            : rule.rule_type === "title" &&
                              rule.rule_config &&
                              rule.rule_config.titles &&
                              rule.rule_config.titles.length > 0
                            ? _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(rule.rule_config.titles.length) +
                                    " title(s): " +
                                    _vm._s(
                                      _vm.formatTitles(rule.rule_config.titles)
                                    ) +
                                    "\n              "
                                )
                              ])
                            : _c("span", { staticClass: "text-muted" }, [
                                _vm._v("No criteria configured")
                              ])
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "span",
                            {
                              class: rule.enabled
                                ? "label label-success"
                                : "label label-default"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    rule.enabled ? "Enabled" : "Disabled"
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-xs btn-default",
                              attrs: { disabled: !_vm.canManageSubgroups },
                              on: {
                                click: function($event) {
                                  return _vm.editRule(rule)
                                }
                              }
                            },
                            [_vm._v("\n                Edit\n              ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-xs",
                              class: rule.enabled
                                ? "btn-warning"
                                : "btn-success",
                              attrs: { disabled: !_vm.canManageSubgroups },
                              on: {
                                click: function($event) {
                                  return _vm.toggleRuleStatus(rule)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(rule.enabled ? "Disable" : "Enable") +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-xs btn-danger",
                              attrs: { disabled: !_vm.canManageSubgroups },
                              on: {
                                click: function($event) {
                                  return _vm.deleteRule(rule)
                                }
                              }
                            },
                            [_vm._v("\n                Delete\n              ")]
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { disabled: !_vm.canManageSubgroups },
                on: { click: _vm.showAddRuleForm }
              },
              [_vm._v("\n        Add Rule\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [_vm._v("\n        Close\n      ")]
            )
          ]),
          _vm._v(" "),
          _vm.showRuleForm
            ? _c("div", { staticClass: "panel panel-default" }, [
                _c("div", { staticClass: "panel-heading" }, [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.editingRule ? "Edit Rule" : "Add Rule"))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "panel-body" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.saveRule.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.ruleForm.enabled,
                                  expression: "ruleForm.enabled"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.ruleForm.enabled)
                                  ? _vm._i(_vm.ruleForm.enabled, null) > -1
                                  : _vm.ruleForm.enabled
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.ruleForm.enabled,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "enabled",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "enabled",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.ruleForm, "enabled", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v("\n                Enabled\n              ")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "help-block" }, [
                          _vm._v(
                            "When enabled, this rule will automatically assign users to this subgroup."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "rule_type" } }, [
                          _vm._v("Rule Type")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.ruleForm.rule_type,
                                expression: "ruleForm.rule_type"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: "rule_type", required: "" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.ruleForm,
                                  "rule_type",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "school" } }, [
                              _vm._v("School-based")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "title" } }, [
                              _vm._v("Title-based")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "help-block" }, [
                          _vm.ruleForm.rule_type === "school"
                            ? _c("span", [
                                _vm._v(
                                  "\n                Users are assigned to this subgroup based on their school assignment.\n              "
                                )
                              ])
                            : _vm.ruleForm.rule_type === "title"
                            ? _c("span", [
                                _vm._v(
                                  "\n                Users are assigned to this subgroup based on their title/role.\n              "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.ruleForm.rule_type === "school"
                        ? _c("div", { staticClass: "form-group schools" }, [
                            _c("legend", [_vm._v("Schools")]),
                            _vm._v(" "),
                            _vm.loadingSchools
                              ? _c("div", { staticClass: "text-muted" }, [
                                  _c("i", {
                                    staticClass: "fa fa-spinner fa-spin"
                                  }),
                                  _vm._v(" Loading schools...\n            ")
                                ])
                              : _c("div", [
                                  _vm.schools.length === 0
                                    ? _c(
                                        "div",
                                        { staticClass: "alert alert-warning" },
                                        [
                                          _vm._v(
                                            "\n                No schools found in this domain.\n              "
                                          )
                                        ]
                                      )
                                    : _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "input-mode-toggle" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn btn-xs",
                                                class:
                                                  _vm.schoolInputMode === "list"
                                                    ? "btn-primary"
                                                    : "btn-default",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.switchSchoolInputMode(
                                                      "list"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("List")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn btn-xs",
                                                class:
                                                  _vm.schoolInputMode ===
                                                  "paste"
                                                    ? "btn-primary"
                                                    : "btn-default",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.switchSchoolInputMode(
                                                      "paste"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Paste")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.schoolInputMode === "list"
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "schools-filter-controls"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.schoolSearchTerm,
                                                            expression:
                                                              "schoolSearchTerm"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "text",
                                                          placeholder:
                                                            "Search schools...",
                                                          "aria-label":
                                                            "Filter schools"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.schoolSearchTerm
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.schoolSearchTerm =
                                                              $event.target.value
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "filter-options"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "checkbox"
                                                        },
                                                        [
                                                          _c("label", [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.showSelectedOnly,
                                                                  expression:
                                                                    "showSelectedOnly"
                                                                }
                                                              ],
                                                              attrs: {
                                                                type: "checkbox"
                                                              },
                                                              domProps: {
                                                                checked: Array.isArray(
                                                                  _vm.showSelectedOnly
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.showSelectedOnly,
                                                                      null
                                                                    ) > -1
                                                                  : _vm.showSelectedOnly
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$a =
                                                                      _vm.showSelectedOnly,
                                                                    $$el =
                                                                      $event.target,
                                                                    $$c = $$el.checked
                                                                      ? true
                                                                      : false
                                                                  if (
                                                                    Array.isArray(
                                                                      $$a
                                                                    )
                                                                  ) {
                                                                    var $$v = null,
                                                                      $$i = _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                    if (
                                                                      $$el.checked
                                                                    ) {
                                                                      $$i < 0 &&
                                                                        (_vm.showSelectedOnly = $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                    } else {
                                                                      $$i >
                                                                        -1 &&
                                                                        (_vm.showSelectedOnly = $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                    }
                                                                  } else {
                                                                    _vm.showSelectedOnly = $$c
                                                                  }
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(
                                                              "\n                          Show selected only\n                        "
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "selected-count"
                                                        },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.ruleForm
                                                                  .school_uuids
                                                                  .length
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" of "),
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.schools
                                                                  .length
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(
                                                            " schools selected\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.filteredSchools.length === 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "text-muted"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    No schools match your search.\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "schools-list"
                                                    },
                                                    _vm._l(
                                                      _vm.filteredSchools,
                                                      function(school) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: school.uuid,
                                                            staticClass:
                                                              "checkbox"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .ruleForm
                                                                        .school_uuids,
                                                                    expression:
                                                                      "ruleForm.school_uuids"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  type:
                                                                    "checkbox",
                                                                  "aria-label":
                                                                    "select school: " +
                                                                    school.name
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    school.uuid,
                                                                  checked: Array.isArray(
                                                                    _vm.ruleForm
                                                                      .school_uuids
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm
                                                                          .ruleForm
                                                                          .school_uuids,
                                                                        school.uuid
                                                                      ) > -1
                                                                    : _vm
                                                                        .ruleForm
                                                                        .school_uuids
                                                                },
                                                                on: {
                                                                  change: function(
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm
                                                                          .ruleForm
                                                                          .school_uuids,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c = $$el.checked
                                                                        ? true
                                                                        : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v =
                                                                          school.uuid,
                                                                        $$i = _vm._i(
                                                                          $$a,
                                                                          $$v
                                                                        )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            _vm.ruleForm,
                                                                            "school_uuids",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            _vm.ruleForm,
                                                                            "school_uuids",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        _vm.ruleForm,
                                                                        "school_uuids",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    school.name
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                            ])
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "school-paste-section"
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "help-block" },
                                                  [
                                                    _vm._v(
                                                      "Paste school names, one per line. Names are matched case-insensitively. Unrecognized names will be shown as warnings."
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.schoolPasteInput,
                                                      expression:
                                                        "schoolPasteInput"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control school-paste-input",
                                                  attrs: {
                                                    placeholder:
                                                      "Paste school names, one per line...",
                                                    rows: "6",
                                                    "aria-label":
                                                      "Paste school names"
                                                  },
                                                  domProps: {
                                                    value: _vm.schoolPasteInput
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.schoolPasteInput =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-default school-paste-apply",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click:
                                                        _vm.applySchoolPaste
                                                    }
                                                  },
                                                  [_vm._v("Apply")]
                                                ),
                                                _vm._v(" "),
                                                _vm.schoolPasteApplyMessage
                                                  ? _c(
                                                      "alert",
                                                      {
                                                        attrs: {
                                                          type: "success"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.schoolPasteApplyMessage
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.schoolPasteUnmatched
                                                  .length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "alert alert-warning school-paste-unmatched"
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "The following school names were not recognized and have been skipped:"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "school-paste-unmatched-list"
                                                          },
                                                          _vm._l(
                                                            _vm.schoolPasteUnmatched,
                                                            function(name) {
                                                              return _c(
                                                                "li",
                                                                { key: name },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(name)
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                      ])
                                ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.ruleForm.rule_type === "title"
                        ? _c("div", { staticClass: "form-group titles" }, [
                            _c("legend", [_vm._v("Titles")]),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "help-block",
                                attrs: { id: "title-help-text" }
                              },
                              [
                                _vm._v(
                                  "\n              Select titles from domain users or add a custom title. Users with any of these titles will be assigned to this subgroup.\n              Matching is case-insensitive and requires an exact match.\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-mode-toggle" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-xs",
                                  class:
                                    _vm.titleInputMode === "individual"
                                      ? "btn-primary"
                                      : "btn-default",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.switchTitleInputMode(
                                        "individual"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Individual")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-xs",
                                  class:
                                    _vm.titleInputMode === "paste"
                                      ? "btn-primary"
                                      : "btn-default",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.switchTitleInputMode("paste")
                                    }
                                  }
                                },
                                [_vm._v("Paste")]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "title-selector" },
                              [
                                _vm.loadingTitles
                                  ? _c("div", { staticClass: "text-muted" }, [
                                      _c("i", {
                                        staticClass: "fa fa-spinner fa-spin"
                                      }),
                                      _vm._v(
                                        " Loading titles...\n              "
                                      )
                                    ])
                                  : _vm.titleInputMode === "individual"
                                  ? [
                                      _vm.existingTitles.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "titles-list",
                                              attrs: {
                                                role: "group",
                                                "aria-describedby":
                                                  "title-help-text"
                                              }
                                            },
                                            _vm._l(_vm.existingTitles, function(
                                              title
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: title,
                                                  staticClass: "checkbox"
                                                },
                                                [
                                                  _c("label", [
                                                    _c("input", {
                                                      attrs: {
                                                        type: "checkbox",
                                                        "aria-label":
                                                          "Select title: " +
                                                          title
                                                      },
                                                      domProps: {
                                                        checked: _vm.isTitleSelected(
                                                          title
                                                        )
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.toggleTitle(
                                                            title
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(title) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.customSelectedTitles.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "titles-list custom-titles-list",
                                              attrs: {
                                                role: "group",
                                                "aria-label": "Custom titles"
                                              }
                                            },
                                            _vm._l(
                                              _vm.customSelectedTitles,
                                              function(title) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: title,
                                                    staticClass: "checkbox"
                                                  },
                                                  [
                                                    _c("label", [
                                                      _c("input", {
                                                        attrs: {
                                                          type: "checkbox",
                                                          checked: "",
                                                          "aria-label":
                                                            "Remove custom title: " +
                                                            title
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.toggleTitle(
                                                              title
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(title) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted"
                                                        },
                                                        [_vm._v("(custom)")]
                                                      )
                                                    ])
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "custom-title-section" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "input-group" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.customTitleInput,
                                                    expression:
                                                      "customTitleInput"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "text",
                                                  placeholder:
                                                    "Add a custom title...",
                                                  "aria-label":
                                                    "Custom title input",
                                                  "aria-describedby":
                                                    "title-help-text"
                                                },
                                                domProps: {
                                                  value: _vm.customTitleInput
                                                },
                                                on: {
                                                  keyup: function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    )
                                                      return null
                                                    return _vm.addCustomTitle.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                  input: function($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.customTitleInput =
                                                      $event.target.value
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "input-group-btn"
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-default",
                                                      attrs: {
                                                        type: "button",
                                                        disabled: !_vm.customTitleInput.trim()
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.addCustomTitle
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Add\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.customTitleError
                                            ? _c(
                                                "p",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.customTitleError)
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  : _c(
                                      "div",
                                      { staticClass: "title-paste-section" },
                                      [
                                        _c("p", { staticClass: "help-block" }, [
                                          _vm._v(
                                            "Paste titles, one per line. Duplicates (case-insensitive) will be removed automatically."
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.titlePasteInput,
                                              expression: "titlePasteInput"
                                            }
                                          ],
                                          staticClass:
                                            "form-control title-paste-input",
                                          attrs: {
                                            placeholder:
                                              "Paste titles, one per line...",
                                            rows: "6",
                                            "aria-label": "Paste titles"
                                          },
                                          domProps: {
                                            value: _vm.titlePasteInput
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.titlePasteInput =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-default title-paste-apply",
                                            attrs: { type: "button" },
                                            on: { click: _vm.applyTitlePaste }
                                          },
                                          [_vm._v("Apply")]
                                        ),
                                        _vm._v(" "),
                                        _vm.titlePasteApplyMessage
                                          ? _c(
                                              "alert",
                                              { attrs: { type: "success" } },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.titlePasteApplyMessage
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                _vm._v(" "),
                                _vm.validSelectedTitles.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "selected-titles",
                                        attrs: { role: "list" }
                                      },
                                      _vm._l(_vm.validSelectedTitles, function(
                                        title
                                      ) {
                                        return _c(
                                          "span",
                                          {
                                            key: title,
                                            staticClass:
                                              "title-chip label label-info",
                                            attrs: { role: "listitem" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(title) +
                                                "\n                  "
                                            ),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn-close-chip",
                                                attrs: {
                                                  type: "button",
                                                  "aria-label":
                                                    "Remove title: " + title
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleTitle(
                                                      title
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-times"
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "submit", disabled: _vm.saving }
                          },
                          [
                            _vm.saving
                              ? _c("span", [
                                  _c("i", {
                                    staticClass: "fa fa-spinner fa-spin"
                                  }),
                                  _vm._v(" Saving...")
                                ])
                              : _c("span", [_vm._v("Save")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            attrs: { type: "button", disabled: _vm.saving },
                            on: { click: _vm.cancelRuleForm }
                          },
                          [_vm._v("\n              Cancel\n            ")]
                        )
                      ])
                    ]
                  )
                ])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("small", [
        _vm._v(
          "Rules automatically assign users to this subgroup based on the users attributes."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }